module.exports = __webpack_public_path__ + "assets/img/34c9bd90c6ec5eaa11fb9fe7daadebf8.svg";